module.exports = __webpack_public_path__ + "img/PK.e5c80180.svg";